export const portalLiveStats = (state) => {
  return state.portalLiveStats;
};
